module.exports = __webpack_public_path__ + "static/media/20180522-LCS-009-5.6e8fd6d6.jpg";